import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { catchError } from 'rxjs/operators';

import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { StringUtil } from 'src/app/core/framework/utils/string-util';
import { environment } from 'src/environments/environment';
import { IEndereco } from '../../endereco.interface';
import { GisService } from '../../gis/gis.service';
import { GeocodeResult, Location } from '../../gis/model/google-maps-geocode-result.interface';


@Component({
  selector: 'app-endereco-mapa',
  templateUrl: './endereco-mapa.component.html',
  styleUrls: ['./endereco-mapa.component.css']
})
export class EnderecoMapaComponent implements OnInit, AfterViewInit {

  private map: google.maps.Map;
  private marcadores: google.maps.Marker[] = [];
  private marcadorHandMapClick: google.maps.Marker;

  @Input() latitude: number;
  @Input() longitude: number;

  @Output() adicionarMarcadorEvent = new EventEmitter<Location>();
  @Output() novaLocalizacaoEvent = new EventEmitter<Location>();
  @Output() novaLocalizacaoParaPreencherEnderecoEvent = new EventEmitter<Location>();

  constructor(
    private gisService: GisService,
    private toasterService: ToasterService
  ) { }

  options: any;

  overlays: any[];

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.inicializarMapa(0);
  }


  inicializarMapa(iteracao: number): void {
    if( !document.getElementById("endereco-mapa") || !google ){
      if(iteracao > 5){
        return null;
      }
      setTimeout(() => this.inicializarMapa(++iteracao), 500);
      return null;
    }

    const _lat = ( this.latitude ? this.latitude : environment.brasil_centroid.lat );
    const _lng = ( this.longitude ? this.longitude : environment.brasil_centroid.lng );

    this.options = {
      center: {
        lat: _lat,
        lng: _lng
      },
      zoom: 4
    };

    this.overlays = [
    ];

    this.map = new google.maps.Map(
        document.getElementById("endereco-mapa") as HTMLElement,
        this.options
    );
    this.map.addListener("click", this.handleMapClick.bind(this));

    if ( this.latitude && this.longitude ) {
      const zoomIn = true;
      this.adicionarMarcador({ lat: this.latitude,
                               lng: this.longitude },
                               zoomIn );
    }

  }

  handleMapClick(event) {
    const location: Location = event.latLng.toJSON();
    this.removerTodosOsMarcadores();

    const zoomIn = false;
    this.marcadorHandMapClick = this.adicionarMarcador(location, zoomIn);

    this.novaLocalizacaoParaPreencherEnderecoEvent
        .emit(location);
  }

  getMarcadorHandMapClick(): google.maps.Marker {
    return this.marcadorHandMapClick;
  }

  adicionarMarcador(location: Location, zoomIn: boolean): google.maps.Marker {
    const map = this.map;
    const marker = new google.maps.Marker({
      position: location,
      map,
      title: ''
    });
    this.marcadores.push(marker);
    map.panTo(location);

    if (map.getZoom() < 16) {
      map.setZoom(16);
    }

    this.adicionarMarcadorEvent.emit(location);

    return marker;
  }

  removerTodosOsMarcadores(): void {
    if ( this.marcadores ) {
      this.marcadores
          .forEach(marker => {
            marker.setMap(null);
          })
    }

    this.adicionarMarcadorEvent.emit(null);
  }

  parseEnderecoParaGoogleGeocodeURL(endereco: IEndereco): string {
    let texto = '';
    if ( endereco.cep ) {
      texto += 'cep ' + StringUtil.extrairNumeros(endereco.cep);
    }

    if ( endereco.cidade && endereco.cidade.nome ) {
      if ( texto ) {
        texto += ', ';
      }
      texto += 'cidade ' + endereco.cidade.nome
    }

    // if ( endereco.bairro ) {
    //   if ( texto ) {
    //     texto += ', ';
    //   }
    //   texto += 'bairro ' + endereco.bairro;
    // }

    if ( endereco.logradouro ) {
      if ( texto ) {
        texto += ', ';
      }
      texto += endereco.logradouro;
    }

    if ( endereco.numero ) {
      if ( texto ) {
        texto += ', ';
      }
      texto += 'numero ' + endereco.numero;
    }

    return texto;
  }

  adicionarMarcadorComCep(endereco: IEndereco, removerMarcadores: boolean): void {
    if ( removerMarcadores ) {
      this.removerTodosOsMarcadores();
    }

    const toasterId = this.toasterService.wait('Atualizando localização no mapa...');

    const enderecoParaGeocode = this.parseEnderecoParaGoogleGeocodeURL(endereco);
    this.gisService
        .geocode(enderecoParaGeocode, endereco.estado.sigla)
        .pipe(
          catchError(err => {
            this.toasterService.clearWait(toasterId);
            return err;
          })
        )
        .subscribe( (geocodeResult: GeocodeResult) => {
          this.toasterService.clearWait(toasterId);
          let location: Location = null;

          if ( geocodeResult &&
               geocodeResult.results &&
               geocodeResult.results.length > 0 &&
               geocodeResult.status === 'OK' ) {

            location = geocodeResult.results[0].geometry.location;
            const zoomIn = true;
            this.adicionarMarcador(location, zoomIn);
          }
          else {
            this.toasterService.warning('Localização não encontrada');
          }

          this.novaLocalizacaoEvent.emit(location);
        });
  }


}
